import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

import ActionText from '../../../../../../../../../components/ActionText'

import useStyles from '../styles'

const UploadedFile = ({ requestedFile, uploadedFile, handleFileDownloading }) => {
  const classes = useStyles()

  const requestedFileName = requestedFile?.file_name
  const uploadedFileName = uploadedFile?.name

  const handleFileDownload = useCallback(() => {
    handleFileDownloading({
      fileData: {
        url: uploadedFile?.file_url,
        file_name: uploadedFile?.name
      },
      autoDownload: false
    })
  }, [handleFileDownloading, uploadedFile])

  return (
    <div className={classes.nameField}>
      <div className={classes.nameFieldTexts}>
        <p className={classes.nameSecondaryText}>{requestedFileName}</p>
        <ActionText
          className={classes.nameMainText}
          onClick={handleFileDownload}
          isDarkGrey={true}
          underlineOnHover={true}
        >
          {uploadedFileName}
        </ActionText>
      </div>
      {uploadedFile?.comment && <p className={classes.uploadedFileComment}>{uploadedFile.comment}</p>}
    </div>
  )
}

UploadedFile.propTypes = {
  uploadedFile: PropTypes.object.isRequired,
  handleFileDownloading: PropTypes.func.isRequired
}

export default UploadedFile
